// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { hiraganas } from "./hiraganaList";
import { katakana } from "./katakana";

// Punctuation and marks that appear in the keyboard's kana lists but aren't
// actual kana characters, so they're excluded from writing practice.
const EXCLUDED_SYMBOLS = new Set([" ", "、", "。", "？", "！", "ー", "・", "ヰ", "ヱ", "ヴ"]);

// Kept in the reference list so converters can still recognise historical
// spelling, but not part of modern Hiragana writing practice.
const OBSOLETE_HIRAGANA_SYMBOLS = new Set(["ゐ", "ゑ"]);

function isWritableKana(item) {
    return (
        item.symbol.length === 1 &&
        !EXCLUDED_SYMBOLS.has(item.symbol) &&
        // Small kana (っ ゃ ゅ ょ, katakana's small vowels, etc.) only appear
        // as part of combination characters in normal writing, so they're
        // excluded as standalone practice entries.
        !item.romaji.startsWith("small-")
    );
}

export const hiraganaWritingList = hiraganas.filter(
    (item) => isWritableKana(item) && !OBSOLETE_HIRAGANA_SYMBOLS.has(item.symbol)
);
export const katakanaWritingList = katakana.filter(isWritableKana);
